<mb-header [notificationCount]="(notificationCount$ | async) || 0"></mb-header>

<div class="route-wrapper">
  <router-outlet></router-outlet>
</div>

@if ((isLoading$ | async) || false) {
  <div class="loader-overlay">
    <mb-buffering></mb-buffering>
  </div>
}

<mb-footer></mb-footer>

@if (favoritesOpen) {
  <mb-favorites-modal (closed)="closeFavorites()"></mb-favorites-modal>
}
